module.exports = __webpack_public_path__ + "img/germany.85ca59c6.png";